export default "assets/images/eye-762f11ae.svg";